var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.Constants.RUOLI_MANTRA, function (mantraObj, mantra_id) {
      var _obj
      return _c(
        "span",
        {
          key: mantra_id,
          staticClass: "ruolo-mantra",
          class:
            ((_obj = {}),
            (_obj["ruolo-mantra" + mantra_id] = true),
            (_obj.outlined = !_vm.selectedRuoliMantra.includes(mantra_id)),
            _obj),
          on: {
            click: function ($event) {
              return _vm.toggleRuoloMantra(mantra_id)
            },
          },
        },
        [_vm._v(_vm._s(_vm.ruoloMantra(mantra_id)))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }